import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('lineChartCanvas') lineChartCanvas!: ElementRef<HTMLCanvasElement>;
  private lineChartContext!: CanvasRenderingContext2D;
  @Input() data: any[] = [];
  customData: any = [];
  customLabel: any = [];
  colorIndex = 0;
  lineChartData: any = [];
  private chart: any;
  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    this.lineChart(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.data?.currentValue){
      this.data = changes.data.currentValue;
      const context = this.lineChartCanvas?.nativeElement?.getContext('2d');
      if (context) {
        this.lineChart(this.data);
      }
    }
  }

  lineChart(data: any[]): void {
    const labels = this.customLabel;
    const context = this.lineChartCanvas?.nativeElement?.getContext('2d');
    if (!context) {
      return;
    }
    this.lineChartContext = context;

    const datasets = this.dataSetMethods(data);
    this.customLabel =  ['', ...this.customLabel];

    this.chart = new Chart(context, {
      type: 'line',
      data: {
        labels : this.customLabel,
        datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 15,
            boxWidth: 8,
            font: {
              size: 11
            }
            }
          },
          datalabels: {
            display: false,
            radius: 10
          },
          title: {
            display: true,

          },
        },
        elements: {
          point: {
            radius: 5
          }
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Year'
            },
            grid: {
              display: true,
            },
            beginAtZero: false,
          },
          y: {
            title: {
              display: true,
              text: 'Value'
            },
            ticks: {
              precision: 0
            },
            grid: {
              display: true,
            },
             border: {
               dash: [2, 4],
             },
            beginAtZero: false,

          }
        }
      }
    });
  }

 dataSetMethods(data: any[]): any[] {
  const fixedColors = ['#2EB2AA', '#458AAD', '#BE7FDB', '#58B22E', '#DB8A7F', '#66BEFE', '#FED766', '#6DBC48', '#7F85DB', '#FE66C1', '#00A86B', '#00625F', '#008080', '#4169E1', '#4682B4'];
  const dataSets: any[] = [
  ];
  const labelObj: any = {};
  data.forEach((el: any, index) => {
    const color = fixedColors[index];
    const obj: any = {
      backgroundColor: color,
      borderColor: color,
      barThickness: 60,
      maxBarThickness: 75,
    };
    obj.label = el.question_label || el.name;
    const values = el.values.sort((a: any, b: any) => a.financial_year - b.financial_year);
    obj.data = values.map((item: any) => {
      labelObj[item.financial_year] = 1;
      return item.total_count;
    });

    obj.data = ['', ...obj.data];

    dataSets.push(obj);
  });
  this.customLabel = Object.keys(labelObj).sort((a, b) => Number(a) - Number(b));
  return dataSets;
}

 generateRandomColor(): string {
  const fixedColors = ['#2EB2AA', '#458AAD', '#BE7FDB', '#58B22E', '#DB8A7F', '#66BEFE', '#FED766', '#6DBC48', '#7F85DB', '#FE66C1'];
  const color = fixedColors[this.colorIndex];
  this.colorIndex = (this.colorIndex + 1) % fixedColors.length; // Cycle through the colors
  return color;
}

randomColorSet(): string {
  const color = Math.floor(0x1000000 * Math.random()).toString(16);
  return '#' + ('000000' + color).slice(-6);
}

firstLetterCaptial(value: string): string{
  if (value) {
    const sentence: any = value.split('_');
    return sentence.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
  return '';
}

}



